import { FirstSectionShop } from "./components/firstSection";


export const ShopPage = () => {
    return (
        <div>
            <FirstSectionShop/>
        </div>
    );
};

